import { always, apiFetch } from 'utils'

export function getHints (hint) {
  return apiFetch(`/lincusfacultysearch/${hint}`)
  .catch(always([]))
}

export function getSearchResults (hint) {
  return apiFetch(`/facultysearch/${window.encodeURIComponent(hint)}`)
  .catch(always([]))
}

export function getSingle (id) {
  return apiFetch(`/lincusfacultyprofile/${id}`)
  .catch(always([]))
}



// WEBPACK FOOTER //
// ./resources/assets/js/transport/faculty.js